enum TemplateNodeTypeEnum {
  Page = "Page",
  FormGroup = "Form Group",
  Element = "Element",
  //Option = "Option",
}

export { TemplateNodeTypeEnum };
